<template>
    <div>
        <!-- ALERTAS -->
        <alert-container :messages="msgs"/>
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button 
                    class="save-btn" 
                    type="button" 
                    @click="save" 
                    :disabled="isSaving">
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <!-- CABEÇALHO + CAMPOS TURNO -->
        <div class="page page-container">
            <div class="columns is-multiline turno-header">
                <div class="column is-full">
                    <v-input 
                        ref="descricaoInput"
                        v-model="turno.descricao"
                        title='titulo-turno'
                        id='titulo'
                        required
                        placeholder='titulo-turno-placeholder'
                        msg='msg-campo-obrigatorio'
                        :maxlength="255"
                        :invalid="!turno.descricao"
                    />
                </div>
            </div>
                    <!-- CABEÇALHO PERIODOS -->
            <div class="periodos-header" v-if="$route.params.id">
                <div class="middle-title">
                    <h1 class="title mid">{{ $t('periodos') }}</h1>
                </div>
                <div class="control-btns">
                    <button class="save-btn" type="button" @click="addPeriodo">
                        {{ $t('adicionar-periodo') }}
                    </button>
                </div>
            </div>
            <!-- LISTAGEM PERIODOS -->
            <div class="list-periodos registry-wrapper" v-if="$route.params.id">
                <container-loader v-if="listLoading && !$store.getters.isLoading"/>
                <empty-table-message 
                    v-if="periodos && !periodos.length"
                    msg="msg-nao-ha-periodos-no-turno"
                />
                <b-table
                    v-else
                    class="data-table"
                    :data="periodos"
                    @sort="sortTable"
                    backend-sorting
                >
                        <b-table-column
                            class="td-center"
                            v-for="(f, i) in periodosFields"
                            :key="i"
                            :field="f.key"
                            :label="f.label ? $t(f.label) : ''"
                            :class="{'excluir-field': f.key == 'excluir', 'no-events': periodoLoading > -1 || periodoDel > -1}"
                            :sortable="f.sortable"
                            :width="f.width"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'dia'">
                                {{ $t(getLabelWeekday(props.row[f.key])) }}
                            </div>
                            <div 
                                v-else-if="f.key == 'descricao'" 
                                :class="{'disabled': periodoLoading == props.row.idperiodo}"
                                @click="openPeriodo(props.row.idperiodo)"
                            >
                                {{ props.row[f.key].trim() != '' ? props.row[f.key] : $t('sem-descricao-a') }}
                            </div>
                            <div v-else-if="f.key == 'excluir'">
                                <b-button 
                                    type="is-danger" 
                                    icon-right="delete" 
                                    :loading="periodoDel == props.row.idperiodo"
                                    :disabled="periodoDel == props.row.idperiodo"
                                    @click="promptForDel(props.row)" 
                                />
                            </div>
                            <div v-else>
                                {{props.row[f.key]}}
                            </div>
                        </b-table-column>
                </b-table>
                <b-pagination
                    :total="total"
                    :current.sync="page"
                    :per-page="pageSize"
                    order='is-centered'
                    @change="getPage"
                />
            </div>
        </div>

        <!-- MODAL EDIÇÃO PERÍODO -->
        <b-modal
            :active.sync="modalPeriodoOpen">
            <PeriodoModal
                :idperiodo="idperiodo"
                @fecharModal="fecharModal"
            />
        </b-modal>
    </div>
</template>

<script>
import Message from "@/models/Message";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import TurnoService from "@/services/TurnoService";
import PeriodoService from "@/services/promotor/PeriodoService";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import ColaboradorService from "@/services/ColaboradorService";
import PeriodoModal from "@/components/vendas/turno/modal/PeriodoModal"
import TurnoValidation from "@/services/validations/TurnoValidation";

export default {
    components: {
        PeriodoModal,
        ContainerLoader,
    },
    data() {
        return {
            id: this.$route.params.id,
            service: new TurnoService(this.$http, this.$router),
            periodoService: new PeriodoService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            periodosFields: [
                { key: 'descricao', label: 'descricao', sortable: true },
                { key: 'dia', label: 'dia', width: 150, sortable: true },
                { key: 'excluir', width: 70, sortable: false }
            ],
            empresas: [],
            empresasLoading: false,
            vendedores: [],
            vendedoresLoading: false,
            periodos: [],
            turno: {},
            title: '',
            idperiodo: 0,
            msgs: [],
            page: 1,
            pageSize: 15,
            total: 0,
            column: 'descricao',
            order: 'asc',
            modalPeriodoOpen: false,
            isSaving: false,
            modalOpen: false,
            validation: null,
            listLoading: false,
            periodoLoading: -1,
            periodoDel: -1,
            isUpdate: false,
            abrev: this.$route.meta.contexto,
            isDespesa: this.$route.meta.contexto == "despesas",
        };
    },
    created() {
        if (this.$route.params.id) {
            this.isUpdate = true;
        }

        this.validation = new TurnoValidation(this.msgs);

        if (this.isDespesa) this.abrev = this.$route.meta.contexto.slice(0,3);
        if (this.$route.params.id) {
            this.carregarTurno(this.id);
            this.carregarPeriodos(this.id);
        }

        this.carregarEmpresas('');
        this.carregarVendedores('');
    },
    methods: {
        save() {
            this.turno = this.mapTosave(this.turno);
            if (this.validation && this.validation.validate(this.turno, this.$refs)) {
                this.isSaving = true;
                this.service.save(this.turno)
                    .then(body => {
                        if (body.status != 200) {
                            console.error(`[TURNO] Erro status ${body.status} ao salvar turno.`);
                            console.error(`[TURNO] Mensagem: ${body.message}`);

                            let error = "msg-erro-salvar-turnos";
                            if(body.message == "msg-descricao-duplicada") {
                                error = body.message;
                            }
                            this.msgs.push(new Message("error", error, true));
                        } else {
                            let msg = this.turno.idturno ? "msg-turno-editado" : "msg-turno-salvo";

                            this.turno = body.content;
                            this.msgs.push(new Message("success", msg, true));
                            this.redirectToList(2);
                        }
                    })
                    .catch(e => {
                        console.error('[TURNO] Erro ao salvar turno.', e);
                        this.msgs.push(new Message("error", 'msg-problema-realizar-acao', true));
                    })
                    .finally(_ => {
                        this.isSaving = false;
                    });
            }
        },
        openPeriodo(idperiodo) {
            this.idperiodo = idperiodo
            this.modalPeriodoOpen = true;
        },
        addPeriodo() {
            this.modalPeriodoOpen = true;
        },
        redirectToList(id) {
            setTimeout(() => {
                this.$router.push({
                    name: `${this.abrev}-turno-list`,
                    params: { id: id },
                });
            }, 1000);
        },
        getLabelWeekday(day) {
            switch (day) {
                case "1":
                    return 'segunda';
                case "2":
                    return 'terca';
                case "3":
                    return 'quarta';
                case "4":
                    return 'quinta';
                case "5":
                    return 'sexta';
                case "6":
                    return 'sabado';
                case "7":
                    return 'domingo';
                default:
                    return 'invalido';
            }
        },
        carregarTurno(id) {
            this.service
                .findVendas(id)
                .then(r => {
                    this.turno = r.content;
                    this.title = r.content.descricao;
                })
                .catch(e => {
                    console.error('Erro ao carregar Turnos.', e);
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-carregar-turnos");
                })
        },
        carregarPeriodos(id) {
            this.listLoading = true;

            this.service.findAllPeriodosByTurnoVendas(id, this.page > 1 ? this.page - 1 : 0, this.pageSize, this.column, this.order, '')
                .then(r => {
                    if (r.status != 200) {
                        console.error(`[TURNO] Erro status ${r.status} ao carregar períodos.`);
                        console.error(`[TURNO] Mensagem: ${r.message}`);
                        this.msgs.push(new Message("error", "msg-erro-load-periodos", true));
                    } else {
                        this.periodos = r.content;
                        this.total = r.totalElements;
                    }
                })
                .catch(e => {
                    console.error('[TURNO] Erro ao carregar períodos.', e);
                    this.msgs.push(new Message("error", "msg-erro-load-periodos", true));
                })
                .finally(_ => {
                    this.listLoading = false;
                });
        },
        carregarEmpresas(q) {
            this.empresasLoading = true;

            this.empresaService.findList(q)
                .then(r => {
                    if (r.status != 200) {
                        console.error(`[TURNO] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[TURNO] Mensagem: ${r.message}`);
                    } else {
                        this.empresas = r.content;
                    }
                })
                .catch(e => {
                    console.error('[TURNO] Erro ao carregar empresas.', e);
                })
                .finally(_ => {
                    this.empresasLoading = false;
                });
        },
        carregarVendedores(q) {
            this.empresasLoading = true;

            this.colaboradorService.findListAssociated(q)
                .then(r => {
                    if (r.status != 200) {
                        console.error(`[TURNO] Erro status ${r.status} ao carregar vendedores.`);
                        console.error(`[TURNO] Mensagem: ${r.message}`);
                    } else {
                        this.vendedores = r.content;
                    }
                })
                .catch(e => {
                    console.error('[TURNO] Erro ao carregar vendedores.', e);
                })
                .finally(_ => {
                    this.empresasLoading = false;
                });
        },
        getPage(n) {
            this.page = n;
            this.carregarPeriodos(this.id);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarPeriodos(this.id);
        },
        closePeriodo() {
            this.periodo = {};
            this.periodoTitle = '';
            this.modalPeriodoOpen = false;
        },
        promptForDel(periodo) {
            this.periodoDel = periodo.idperiodo;

            this.$root.confirm({
                message: this.$t('msg-confirmacao-exclusao-n', { n: periodo.descricao }),
                onConfirm: this.delPeriodo,
                onCancel: this.cancelDelPrompt
            });
        },
        cancelDelPrompt() {
            this.periodoDel = -1;
        },
        delPeriodo() {
            this.periodoService.delete(this.periodoDel)
                .then(r => {
                    if (r.status != 200) {
                        console.error(`[PERIODO] Erro status ${r.status} ao remover periodo.`);
                        console.error(`[PERIODO] Mensagem: ${r.message}`);
                        this.msgs.push(new Message("error", "msg-erro-del-periodo", true));
                    } else {
                        this.modalPeriodoOpen = false;
                        this.msgs.push(new Message("success", "msg-success-del-periodo", true));
                        this.carregarPeriodos(this.id);
                    }
                })
                .catch(e => {
                    console.error('[PERIODO] Erro ao remover periodo.', e);
                    this.msgs.push(new Message("error", "msg-erro-del-periodo", true));
                })
                .finally(_ => {
                    this.periodoDel = -1;
                });
        },
        fecharModal() {
            this.idperiodo = 0;
            this.modalPeriodoOpen = false;
            this.carregarPeriodos(this.id);
        },
    }
};
</script>

<style lang="scss" scoped>
@import "./mixins.scss";

.column {
    @include default-size-column;
}

#main {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    height: auto;
    min-height: 100%;

    .page {
        position: relative;

        .turno-header {
            padding-top: 1rem;
            padding-bottom: 0.5rem;

            .column {
                padding: 0.25rem 0.75rem;
            }
        }
    }

    .excluir-field .svg-loader {
        margin-left: 0;
    }

    .btn {
        min-height: 30px;
    }

    .periodos-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 1.25rem;
        padding-right: 1.25rem;
        padding-bottom: 0.75rem;
        padding-left: 0.75rem;

        h1.title.mid {
            padding-bottom: 0;
            margin-right: 0;
        }

        button {
            padding: 10px;
        }
    }

    .modal-es {
        border-radius: 3px;

        .content {
            margin-top: 0px;
        }

        .horarios {
            min-height: 140px;

            .label-tipo {
                align-items: center;
                color: $dark-gray-color;
                font-weight: 600;

                span {
                    margin-top: 1.25rem;
                }
            }
        }

        .add-es {
            justify-content: center;
        }

        .with-del-btn {
            .exclude-btn {
                margin-top: 1.5rem;
                margin-left: 1rem;
            }

            .hour {
                width: 100%;
            }
        }

        button.save-btn,
        button.delete-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 45px;
            padding: 0 15px;
        }
    }
}
</style>